import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading, isConfigured } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-surface-950 flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-primary-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  // Only skip auth in local development without Supabase
  if (import.meta.env.DEV && !isConfigured) {
    return <>{children}</>;
  }

  // In production, always require auth
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
